// The one place a press tells the rest of the studio that credits moved (204).
// Kept apart from lib/credits.ts so the request helper can announce without
// importing the hook that listens.
export const creditEvents: EventTarget = new EventTarget();

export interface Short { needed: number | null; shortBy: number | null; balance: { plan: number; purchased: number } | null; message: string }

export function announceSpent(): void { creditEvents.dispatchEvent(new Event('spent')); }
export function announceShort(detail: Short): void { creditEvents.dispatchEvent(new CustomEvent<Short>('short', { detail })); }
